function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24 18.439C23.8913 18.4444 23.7825 18.4545 23.6737 18.4545C18.5502 18.4553 13.4266 18.4562 8.30297 18.4513C8.10844 18.4511 7.97162 18.5038 7.83281 18.6432C6.23607 20.2466 4.6326 21.8432 3.03053 23.4413C2.97199 23.4997 2.91 23.5547 2.8193 23.6396V18.439H0V3C0.0930469 3.00527 0.186152 3.01518 0.279199 3.01518C8.09309 3.01588 15.9069 3.01588 23.7207 3.01518C23.8138 3.01518 23.9069 3.00527 24 3V18.439Z",
  fill: "#333333"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.2334 8.61134H19.7742V7.24487H4.2334V8.61134Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.2334 11.4181H19.7742V10.0527H4.2334V11.4181Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.22656 14.2254H14.1419V12.8594H4.22656V14.2254Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 16,
  r: 7.5,
  fill: "#FFF3D9",
  stroke: "#333333"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.7221 13.6847V14.7169C21.7221 16.4155 21.7225 18.114 21.721 19.8126C21.7209 19.9012 21.717 19.9936 21.6944 20.0776C21.6276 20.3253 21.4044 20.4804 21.1741 20.4509C20.9455 20.4217 20.7596 20.2118 20.7405 19.9586C20.7362 19.9029 20.7384 19.8466 20.7384 19.7906C20.7383 17.8285 20.7384 15.8665 20.7384 13.9044V13.6911C20.6827 13.7455 20.6454 13.7785 20.6117 13.8154C20.2786 14.1801 19.9487 14.5484 19.6124 14.9097C19.4229 15.1133 19.152 15.1257 18.9558 14.9539C18.768 14.7894 18.7136 14.5008 18.8323 14.2726C18.8622 14.2152 18.9038 14.1632 18.9467 14.1161C19.5796 13.4215 20.213 12.7274 20.8477 12.0348C21.0843 11.7767 21.3727 11.7731 21.6077 12.0289C22.2503 12.7287 22.8913 13.4303 23.5305 14.1339C23.743 14.3679 23.7453 14.6962 23.5448 14.9139C23.3439 15.1321 23.047 15.1266 22.8322 14.8936C22.5049 14.5384 22.1813 14.1791 21.8558 13.8219C21.8208 13.7835 21.7837 13.7477 21.7221 13.6847Z",
  fill: "#333333"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M21.7221 13.6847V14.7169C21.7221 16.4155 21.7225 18.114 21.721 19.8126C21.7209 19.9012 21.717 19.9936 21.6944 20.0776C21.6276 20.3253 21.4044 20.4804 21.1741 20.4509C20.9455 20.4217 20.7596 20.2118 20.7405 19.9586C20.7362 19.9029 20.7384 19.8466 20.7384 19.7906C20.7383 17.8285 20.7384 15.8665 20.7384 13.9044V13.6911C20.6827 13.7455 20.6454 13.7785 20.6117 13.8154C20.2786 14.1801 19.9487 14.5484 19.6124 14.9097C19.4229 15.1133 19.152 15.1257 18.9558 14.9539C18.768 14.7894 18.7136 14.5008 18.8323 14.2726C18.8622 14.2152 18.9038 14.1632 18.9467 14.1161C19.5796 13.4215 20.213 12.7274 20.8477 12.0348C21.0843 11.7767 21.3727 11.7731 21.6077 12.0289C22.2503 12.7287 22.8913 13.4303 23.5305 14.1339C23.743 14.3679 23.7453 14.6962 23.5448 14.9139C23.3439 15.1321 23.047 15.1266 22.8322 14.8936C22.5049 14.5384 22.1813 14.1791 21.8558 13.8219C21.8208 13.7835 21.7837 13.7477 21.7221 13.6847",
  stroke: "#333333",
  strokeWidth: 0.2
});

var SvgQaPublishedIcon = function SvgQaPublishedIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 25,
    viewBox: "0 0 29 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQaPublishedIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Q&A_published_icon.caf62233.svg";
export { ForwardRef as ReactComponent };